import React, { Component } from 'react'

import {
    FirstSectionWrap,
    Block,
    BlockTitle,
    BlockSlogan,
    BlockHead,
    BlockBody,
    CaseIcon,
    About
} from './style'
import config from '../../config/env'
class Case extends Component{
    constructor(){
        super()
    }
    render(){
        return(
            <article>
                <FirstSectionWrap>
                    <div className="block flexSpaceBetween">
                        <div>
                            <BlockTitle>合作案例</BlockTitle>
                            <BlockSlogan>促进增长、合作共赢</BlockSlogan>
                        </div>
                        <img width="495" src={config.baseUrl+"/hitcloud/home/case/case-1-1.png"} />
                    </div>
                </FirstSectionWrap>
                <section>
                    <Block>
                        <BlockHead>
                            众多知名企业，与点云平台牵手合作
                        </BlockHead>
                        <BlockBody>
                            <div className="brandInfo">
                                <CaseIcon>
                                    <img src={config.baseUrl+"/hitcloud/home/case/case-1-2.png"} />
                                </CaseIcon>
                                <p className="info">海尔集团创立于1984年，是全球领先的美好生活解决方案服务商。海尔始终以用户体验为中心，连续12年稳居欧睿国际世界家电第一品牌，服务全球10亿+用户家庭。 <br/> <br/>自2017年，海尔集团旗下空调、冰箱、洗衣机、电视、冷柜、小家电等上线点云互联，累计服务国内用户1亿次。为推动海尔的智慧家庭、生态体验，点云互联成功对接海尔智家，通过一型一码精准识别产品型号，数据网关物联网适配，实现多个业务系统互连，实现各个系统之间信息和流程的共享和管理。方便用户使用移动端与产品的互联互通，坚持了海尔以用户体验为中心的宗旨。</p>
                            </div>
                            <img width="1100" src={config.baseUrl+"/hitcloud/home/case/case-1-3.jpg"}/>
                        </BlockBody>
                        <BlockBody>
                            <div className="brandInfo">
                                <CaseIcon>
                                    <img src={config.baseUrl+"/hitcloud/home/case/case-1-4.png"} />
                                </CaseIcon>
                                <p className="info">
                                    "科技尽善，生活尽美"--美的集团秉承用科技创造美好生活的经营理念，经过52年发展，已成为一家全球化科技集团，产品及服务惠及全球200多个国家和地区约4亿用户。<br/>
                                     为给用户提供方便、快捷、丰富的服务体验，提升消费者的品牌认可度，美的空调自2016年与点云互联合作，通过能效信息码的权威性和便捷性，向用户展示产品宣传页、电子说明书、ROHS认证、铜佳证书、售后电话等云平台SaaS服务。美的空调电子说明书的应用，每年为美的节省印刷成本300多万元。美的使用点云互联平台累计已为1亿多用户提供了服务，秉承了科技创造美好生活的经营理念。<br/>
                                    <strong>400电话查阅了1亿次，电子说明书阅读5000万次，节省纸质说明书制作印刷费300万/年 </strong> <br/><strong>年节约3亿张纸≈10万棵树≈27000吨碳</strong>

                                   
                                </p>
                            </div>
                            <img width="1100" src={config.baseUrl+"/hitcloud/home/case/case-1-5.jpg"}/>
                        </BlockBody>
                        <BlockBody>
                            <div className="brandInfo">
                                <CaseIcon>
                                    <img src={config.baseUrl+"/hitcloud/home/case/case-1-6.png"} />
                                </CaseIcon>
                                <p className="info">
                                    格力电器是目前中国乃至全球最大的集研发、生产、销售、服务于一体的专业化空调企业。
                                    为扩大格力品牌的影响力，顺应线上线下融合趋势，格力应用点云互联云平台，<strong>在能效信息码中加入了格力的品牌战略，
                                    同时力推线上渠道"董明珠的店",在点云互联细分流量里有效的推广格力品牌，并将引流沉淀到"董明珠的店"，
                                    成为格力新零售战略的完美补充。</strong>目前格力集团的21大类产品，近万个型号使用点云互联SaaS服务。
                                </p>
                            </div>
                            <img width="1100" src={config.baseUrl+"/hitcloud/home/case/case-1-7.jpg"}/>
                        </BlockBody>
                        <About>
                            <a href="https://wj.qq.com/s2/8204971/a71a/" target="_blank">申请试用</a>
                            <span>联系顾问</span>
                            <img src={config.baseUrl+"/hitcloud/home/index/phone.png"} />
                        </About>
                    </Block>
                    
                </section>
            </article>
        )
    }
}

export default Case;